module.exports = __webpack_public_path__ + "img/scene5-19.20f712e4.png";